<template>
  <a-spin :spinning="confirmLoading">
      <a-form-model slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="名称">
              <a-input  style="width: 85%" ></a-input>
              <a-button @click="languageModelOpen(dataTable,dataColumn,nameLanguages)" type="primary"  style="left: 3%" >语言</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    <language-model ref="languageModel" @ok="languageOk"></language-model>
  </a-spin>
</template>
<script>
import LanguageModel from "@/components/LanguageModel"
export default {
  components: { LanguageModel },
  name: "languageMdeltest",
  data(){
    return{
      nameLanguages:[],//多语言数组
      applicationCode:'',//应用code
      dataTable:'',//表名
      dataColumn:'',//字段名
      dataId:'',//对应的数据id
      disabled:false,//是否可以编辑
    }
  },
  methods:{
    languageModelOpen(dataTable,dataColumn,languagelist){
      this.$refs.languageModel.edit(this.applicationCode,dataTable,dataColumn,this.dataId,languagelist,this.disabled);
    },
    languageOk(map){
      if(map&&map.dataColumn == this.dataColumn){
        this.nameLanguages = map.languagelist;
      }
    },
  }
}
</script>

<style scoped>

</style>